import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-data",
  "use": "icon-data-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-data\"><path d=\"M1000 768c13.2 0 24 10.8 24 24v80c0 13.2-10.8 24-24 24H24c-13.2 0-24-10.8-24-24V152c0-13.2 10.8-24 24-24h80c13.2 0 24 10.8 24 24v616h872zM912 192H688c-42.8 0-64.2 51.8-34 82l65.8 65.8-144 145.8-111.2-111.2c-9.4-9.4-24.4-9.4-33.8 0L192.8 610c-9.4 9.2-9.6 24.4-0.4 33.8l57 58.8c9.4 9.6 24.8 9.8 34.2 0.2l164.2-164.2 111 111c9.4 9.4 24.6 9.4 34 0l218.4-218.4L878 498c30.2 30.2 82 8.8 82-34V240c0-26.6-21.4-48-48-48z\" fill=\"\" p-id=\"7931\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol